import { createContext, useContext, useEffect, useState } from "react";
import { adminLogin, adminLogout, adminMe } from "@/lib/api";

const AdminAuthContext = createContext(null);

// admin state: null = checking session, false = logged out, {email} = logged in
export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    adminMe()
      .then((data) => setAdmin(data))
      .catch(() => setAdmin(false));
  }, []);

  async function login(email, password) {
    const data = await adminLogin(email, password);
    setAdmin(data);
    return data;
  }

  async function logout() {
    await adminLogout();
    setAdmin(false);
  }

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
